var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.domainName)?_c('div',{staticClass:"domains | u-wizard-padding-bottom"},_vm._l((_vm.domains),function(domain){return _c('domain-result',{key:domain.domain,attrs:{"domain":domain,"ownedDomains":_vm.ownedDomains}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }